package one.healthium.insights.ui.components.items

import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import one.healthium.ui.compose.theme.AppTheme
import one.healthium.ui.compose.theme.black_4
import androidx.compose.ui.tooling.preview.Preview

@Composable
internal fun Header(
    modifier: Modifier = Modifier,
    text: String,
) {
    Text(
        modifier = modifier
            .fillMaxWidth()
            .padding(horizontal = 12.dp)
            .padding(top = 12.dp, bottom = 6.dp),
        text = text,
        style = AppTheme.textStyles.secondary_17_500,
        color = black_4,
    )
}

@Composable
@Preview(showBackground = true)
private fun HeaderPreview() {
    AppTheme {
        Header(Modifier, "Header")
    }
}